import { getCosts, getInterfaceInfo } from "../services/chime";

export const fees = async (mineInput) => {
    const { chimeFtCost, chimeStxCost, dislikeFtCost, likeFtCost } = await getCosts();
    const { payDev, payGaia, devStxAmount, devFtAmount, gaiaStxAmount, gaiaFtAmount } = await getInterfaceInfo();
    
    return {
        getSendMessageTotal: () => {
            const stx_mine_total = mineInput * 1000000; // From users defined value
            if (payDev && payGaia) {
                // If Both true
                return {
                    stx_grand_total: parseInt(stx_mine_total) + parseInt(chimeStxCost) + parseInt(devStxAmount) + parseInt(gaiaStxAmount)
                };
            } else if (payDev) {
                // If payDev true and payGaia false
                return {
                    stx_grand_total: parseInt(stx_mine_total) + parseInt(chimeStxCost) + parseInt(devStxAmount)
                };
            } else if (payGaia) {
                // If payGaia true and payDev false
                return {
                    stx_grand_total: parseInt(stx_mine_total) + parseInt(chimeStxCost) + parseInt(gaiaStxAmount)
                };
            } else {
                // If Both false
                return {
                    stx_grand_total: parseInt(stx_mine_total) + parseInt(chimeStxCost)
                };
            }

        },
        getLikeMessageTotal: () => {
            if (payDev && payGaia) {
                // If Both true
                return {
                    ft_grand_total: parseInt(likeFtCost) + parseInt(chimeFtCost) + parseInt(devFtAmount) + parseInt(gaiaFtAmount)
                };
            } else if (payDev) {
                // If payDev true and payGaia false
                return {
                    ft_grand_total: parseInt(likeFtCost) + parseInt(chimeFtCost) + parseInt(devFtAmount)
                };
            } else if (payGaia) {
                // If payGaia true and payDev false
                return {
                    ft_grand_total: parseInt(likeFtCost) + parseInt(chimeFtCost) + parseInt(gaiaFtAmount)
                };
            } else {
                // If Both false
                return {
                    ft_grand_total: parseInt(likeFtCost) + parseInt(chimeFtCost)
                };
            }

        },
        getDislikeMessageTotal: () => {
            if (payDev && payGaia) {
                // If Both true
                return {
                    ft_grand_total: parseInt(dislikeFtCost) + parseInt(chimeFtCost) + parseInt(devFtAmount) + parseInt(gaiaFtAmount)
                };
            } else if (payDev) {
                // If payDev true and payGaia false
                return {
                    ft_grand_total: parseInt(dislikeFtCost) + parseInt(chimeFtCost) + parseInt(devFtAmount)
                };
            } else if (payGaia) {
                // If payGaia true and payDev false
                return {
                    ft_grand_total: parseInt(dislikeFtCost) + parseInt(chimeFtCost) + parseInt(gaiaFtAmount)
                };
            } else {
                // If Both false
                return {
                    ft_grand_total: parseInt(dislikeFtCost) + parseInt(chimeFtCost)
                };
            }
        },
        getFavorableReplyMessageTotal: () => {
            const stx_mine_total = mineInput * 1000000; // From user input defined value 
            if (payDev && payGaia) {
                // If Both true
                return {
                    stx_grand_total: parseInt(stx_mine_total) + parseInt(chimeStxCost) + parseInt(devStxAmount) + parseInt(gaiaStxAmount),
                    ft_grand_total: parseInt(likeFtCost) + parseInt(chimeFtCost) + parseInt(devFtAmount) + parseInt(gaiaFtAmount)
                };
            } else if (payDev) {
                // If payDev true and payGaia false
                return {
                    stx_grand_total: parseInt(stx_mine_total) + parseInt(chimeStxCost) + parseInt(devStxAmount),
                    ft_grand_total: parseInt(likeFtCost) + parseInt(chimeFtCost) + parseInt(devFtAmount)
                };
            } else if (payGaia) {
                // If payGaia true and payDev false
                return {
                    stx_grand_total: parseInt(stx_mine_total) + parseInt(chimeStxCost) + parseInt(gaiaStxAmount),
                    ft_grand_total: parseInt(likeFtCost) + parseInt(chimeFtCost) + parseInt(gaiaFtAmount)
                };
            } else {
                // If Both false
                return {
                    stx_grand_total: parseInt(stx_mine_total) + parseInt(chimeStxCost),
                    ft_grand_total: parseInt(likeFtCost) + parseInt(chimeFtCost)
                };
            }

        },
        getUnfavorabelReplyMessageTotal: () => {
            const stx_mine_total = mineInput * 1000000; // From user input defined value 
            if (payDev && payGaia) {
                // If Both true
                console.log('payDev & payGaia fired: ' + payDev, payGaia);

                return {
                    stx_grand_total: parseInt(stx_mine_total) + parseInt(chimeStxCost) + parseInt(devStxAmount) + parseInt(gaiaStxAmount),
                    ft_grand_total: parseInt(dislikeFtCost) + parseInt(chimeFtCost) + parseInt(devFtAmount) + parseInt(gaiaFtAmount)
                };
            } else if (payDev) {
                // If payDev true and payGaia false
                console.log('payDev fired: ' + payDev);

                return {
                    stx_grand_total: parseInt(stx_mine_total) + parseInt(chimeStxCost) + parseInt(devStxAmount),
                    ft_grand_total: parseInt(dislikeFtCost) + parseInt(chimeFtCost) + parseInt(devFtAmount)
                };
            } else if (payGaia) {
                // If payGaia true and payDev false
                console.log('payGaia fired: ' + payGaia);
                return {
                    stx_grand_total: parseInt(stx_mine_total) + parseInt(chimeStxCost) + parseInt(gaiaStxAmount),
                    ft_grand_total: parseInt(dislikeFtCost) + parseInt(chimeFtCost) + parseInt(gaiaFtAmount)
                };
            } else {
                // If Both false
                console.log('both fired: ', false);
                return {
                    stx_grand_total: parseInt(stx_mine_total) + parseInt(chimeStxCost),
                    ft_grand_total: parseInt(dislikeFtCost) + parseInt(chimeFtCost)
                };
            }


        }
    }
}